/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 异步组件容器/生成按需加载路由
 * @Date: 2021-10-18 16:52:28
 * @LastEditTime: 2021-10-18 16:53:36
 */

export default function asyncComponent(importComponent) {
  class AsyncComponent extends React.Component {
      constructor(props) {
          super(props);

          this.state = {
              component: null
          };
      }

      async componentDidMount() {
          const { default: component } = await importComponent();

          this.setState({
              component: component
          });
      }

      render() {
          const C = this.state.component;

          return C ? <C {...this.props} /> : null;
      }
  }

  return AsyncComponent

}